module.exports = __webpack_public_path__ + "img/remove-button.88126f8c.svg";